import type React from 'react';

import type { RedditPostComponentsProps } from './types';

export function Footer(_props: RedditPostComponentsProps): React.JSX.Element | null {
	return null;
}
